import script from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true"

import "./ForgotPassword.vue?vue&type=style&index=0&id=562d2855&lang=less&scoped=true"

import exportComponent from "/var/build/production/tenants-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562d2855"]])

export default __exports__